export default __webpack_public_path__ + "static/media/wallet-connect.304e3277.svg";